
import Splide from '@splidejs/splide';

const spliders = document.querySelectorAll('[splide-id]');

if (spliders) {
    spliders.forEach((splide) => {
        new Splide(splide, {
            type: 'loop',
            perPage: 1,
            width: '80%',
            arrows: false,
            paginationDirection: 'ltr',
            paginationKeyboard: true,
            autoplay: true,
            breakpoints: {
                1200: {
                    width: '100%',
                    padding: 0
                }
            }
        }).mount();
    });

}